import allianzKontaktLogo from '@/images/clients/allianzkontakt-logo.jpg'
import type { IPartnerSettings } from '.'

export const AllianzKontakt: IPartnerSettings = {
  partner: 'AllianzKontakt',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://cebia.allianzkontakt.cz/test',
    prep: '',
    production: 'https://cebia.allianzkontakt.cz/prod',
  },
  hosts: [
    'cebia.allianzkontakt.cz',
    //, 'localhost:44470'
  ],
  logo: allianzKontaktLogo
}
